import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { OverlayService } from '../../../services/overlay.service';
import { BeeFreeService } from '../../../services/beefree.service';
import { MaintenanceService } from '../../../services/maintenance.service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
	formFailed = false;
	isBeeFree: boolean;
	apiLoginErrorMsg = 'Please provide a valid email and password.';

	constructor(
		private auth: AuthService,
		private overlay: OverlayService,
		private beeFree: BeeFreeService,
		private maintenance: MaintenanceService
	) {}

	ngOnInit() {
		this.isBeeFree = this.beeFree.isBeeFreeAddon();
		if (this.maintenance.inMaintenance()) {
			this.maintenance.redirectToMaintenancePage();
		}
	}

	submit(values): boolean | void {
		this.auth.newAPILoginWithEmailAndPassword(values.email, values.password).subscribe(
			(resp) => {
				if (!resp.status) {
					this.formFailed = true;
					setTimeout(() => {
						this.formFailed = false;
					}, 2000);
					this.overlay.updateOverlay(true, this.apiLoginErrorMsg, 'alert');
				}
			},
			(err) => {
				this.overlay.updateOverlay(true, this.apiLoginErrorMsg, 'alert');
				this.maintenance.serverMaintenance(err);
			}
		);
	}

	cancelBeeFree() {
		this.beeFree.cancelAddon();
	}
}
